export default __webpack_public_path__ + "static/media/lemonde.fd89b4b8.png";